export const formatDeviceContractForDisplay = (deviceContract: string | undefined): string => {
  if (!deviceContract) {
    return "-";
  }

  if (deviceContract === "PATMO") {
    return "PATMOα";
  }

  if (deviceContract === "dearisController") {
    return "dearis";
  }

  return "Pabbit Lite";
};
